import React, { useState } from "react";
import Dashboard from "../Dashboard/dashboard";
import Faq from "../../shared/FAQ/faq";
import Footer from "../../shared/Footer/footer";

const HomePage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"REITs" | "InvITs">("REITs");

  return (
    <>
      {/* Pass down shared state */}
      <Dashboard activeTab={activeTab} setActiveTab={setActiveTab} />
      <Faq activeTab={activeTab} setActiveTab={setActiveTab} />
      <Footer />
    </>
  );
};

export default HomePage;
